exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a {\r\n  color: gray;\r\n}\r\n\r\n.logo {\r\n  color: #F56400;\r\n  text-decoration: none;\r\n}\r\n\r\n.categories {\r\n  border: 1px solid lightgray;\r\n}\r\n\r\n/* Customize the navbar links to be fill the entire space of the .navbar */\r\n\r\n.navbar .navbar-inner {\r\n    padding: 0;\r\n}\r\n\r\n.navbar .nav {\r\n    margin: 0;\r\n    display: table;\r\n    width: 100%;\r\n}\r\n\r\n.navbar .nav li {\r\n    display: table-cell;\r\n    width: 1%;\r\n    float: none;\r\n}\r\n\r\n.navbar .nav li a {\r\n    font-weight: bold;\r\n    text-align: center;\r\n    border-left: 1px solid rgba(255, 255, 255, .75);\r\n    border-right: 1px solid rgba(0, 0, 0, .1);\r\n}\r\n\r\n.navbar .nav li:first-child a {\r\n    border-left: 0;\r\n    border-radius: 3px 0 0 3px;\r\n}\r\n\r\n.navbar .nav li:last-child a {\r\n    border-right: 0;\r\n    border-radius: 0 3px 3px 0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/sara/epicodus/quasi-etsy/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main